import utils from '../utils';
import {vIcon} from '@/components/form/index';

/**
 * Renders a plain text row for display.
 * @param {CachedColumn} cachedColumn
 * @param {Object} rowData
 * @param {Function} createElement
 * @returns {Array}
 */
export default function textColumn({cachedColumn, rowData, createElement}) {
    const values = utils.getCellValues({cachedColumn, rowData});
    const data = {
        attrs: {title: values.join(utils.joinDelimiter)},
        class: {},
    };
    let children = values.length
        ? values.join(utils.joinDelimiter)
        : [utils.getEmptyCellElement(createElement)];

    if (typeof cachedColumn.props.copy === 'function') {
        data.class['cursor-pointer'] = true;
        Object.assign(data, {
            on: {
                click: () => cachedColumn.props.copy({rowData}),
            },
        });

        if (typeof children === 'string') {
            children = [children];
        }
        children.push(
            createElement('span', {
                props: {size: 'small'},
                class: 'margin-left-s has-tooltip',
                attrs: {'data-tooltip': 'Copy'},
            }, [
                createElement(vIcon, {props: {icon: 'clone'}}),
            ]),
        );
    }

    return ['div', data, children];
}
